import { createAction } from 'redux-actions';
import { createSuccessAction, createFailureAction } from 'utilities/request';

export const addOrganizations = createAction('ORGANIZATIONS/ADD');

export const requestOrganizations = createAction('REQUEST/ORGANIZATIONS');
export const requestOrganizationsSuccess = createSuccessAction(requestOrganizations);
export const requestOrganizationsFailure = createFailureAction(requestOrganizations);

export const requestOrganizationsAddOrganization = createAction(
  'REQUEST/ORGANIZATIONS/ADD_ORGANIZATION',
);
export const requestOrganizationsAddOrganizationSuccess = createSuccessAction(
  requestOrganizationsAddOrganization,
);
export const requestOrganizationsAddOrganizationFailure = createFailureAction(
  requestOrganizationsAddOrganization,
);

export const requestOrganizationsAddCareTeam = createAction('REQUEST/ORGANIZATIONS/ADD_CARETEAM');
export const requestOrganizationsAddCareTeamSuccess = createSuccessAction(
  requestOrganizationsAddCareTeam,
);
export const requestOrganizationsAddCareTeamFailure = createFailureAction(
  requestOrganizationsAddCareTeam,
);
